module.exports = __webpack_public_path__ + "img/CM-KT-25-Cadillac-Lifestyle.4d106f4f.jpg";